import { render, staticRenderFns } from "./MyProfileForm.vue?vue&type=template&id=389e83ae&scoped=true&"
import script from "./MyProfileForm.vue?vue&type=script&lang=js&"
export * from "./MyProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileForm.vue?vue&type=style&index=0&id=389e83ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e83ae",
  null
  
)

export default component.exports